import { IntlShape } from 'react-intl'

import { isIntakeSession } from '@lyrahealth-inc/shared-app-logic/src/features/sessions/utils'

export const getSessionTypeLabel = (intl: IntlShape, session: Parameters<typeof isIntakeSession>[0]): string =>
  isIntakeSession(session)
    ? intl.formatMessage({ defaultMessage: 'Intake', description: 'Session type label' })
    : intl.formatMessage({ defaultMessage: 'Follow-up', description: 'Session type label' })
